import styled from 'styled-components';

export const BodyEmptyStyled = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: calc(100% - 40px);
  height: calc(100% - 40px);
  /* ต้องมากกว่าเมนูล่าง (.menu_mainlayout z-index: 99)
     เดิมเท่ากันพอดี เมนูอยู่หลังกว่าใน DOM เลยทับ modal
     ทำให้ปุ่มคลังภาพ/แฟลช ของจอสแกน QR ถูกบัง */
  z-index: 200;
  display: flex;
  padding: 20px;
  justify-content: center;
  align-items: center;
  .backdrop {
    position: absolute;
    z-index: -1;
    width: 100%;
    height: 100%;
    background: ${({ theme }) => theme.COLORS.BLACK_1}66;
  }
`;
